import { Grid, makeStyles, createStyles, Theme } from "@material-ui/core";
import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { convertFromHTML, convertToHTML } from "draft-convert";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6,
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        containerLabel: {
            textAlign: "left",
        },
        editor: {
            border: "1px solid rgba(0, 0, 0, 0.15)",
            minHeight: "200px",
            borderRadius: 4,
        },
    })
);
export function AnnounceTextFieldMultine(props: {
    id: string;
    label?: string;
    name: string;
    value: string;
    handleChange: (e: any) => void;
}) {
    const classes = styles();
    const { id, label, name, value, handleChange } = props;
    const [editorState, setEditorState] = React.useState(() =>
        value
            ? EditorState.createWithContent(convertFromHTML(value))
            : EditorState.createEmpty()
    );
    const handleChangeEditor = (data: any) => {
        setEditorState(data);
        const currentContentAsHTML = convertToHTML(data.getCurrentContent());
        handleChange({
            target: {
                name,
                value: currentContentAsHTML,
            },
        });
    };

    return (
        <>
            <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                className={classes.containerLabel}
            >
                <label htmlFor={id} className={classes.inputLabel}>
                    {label}
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inpuText}>
                <div className={classes.editor}>
                    <Editor
                        editorState={editorState}
                        onEditorStateChange={handleChangeEditor}
                    />
                </div>
            </Grid>
        </>
    );
}
